var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgNotification = function SvgNotification(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.076 7.724c0-2.339-1.61-4.296-4.05-4.814v-.517c0-.633-.57-1.143-1.276-1.143s-1.276.51-1.276 1.143v.517c-2.44.518-4.05 2.475-4.05 4.814v3.804c0 1.772-1.902 2.954-1.902 4.41a.533.533 0 0 0 .536.527h13.384a.53.53 0 0 0 .537-.528c0-1.455-1.903-2.637-1.903-4.41zM9.75 18.75c.948 0 1.7-.67 1.7-1.523h-3.4c0 .837.764 1.523 1.7 1.523"
  })));
};
export default SvgNotification;